import angular from 'angular';
import { ConfigRouteConfig, ConfigRunSetup } from './config.route';

const appConfigModule = angular.module('app.config', [
	'ncy-angular-breadcrumb'
]);

appConfigModule.config(ConfigRouteConfig).run(ConfigRunSetup);

export default appConfigModule.name;
